export default {"src":"/_next/static/media/dollar-minimalistic_svgrepo.com.abe9685a.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};